import { NgModule } from '@angular/core';

import { IsTruelyPipe } from "./is-truely.pipe";

@NgModule({
    imports: [],
    exports: [
        IsTruelyPipe
    ],
    declarations: [IsTruelyPipe],
    providers: [IsTruelyPipe],
})
export class IsTruelyModule {
}
